// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7023":"af51d8c4e0dec937","9301":"b81fa11a390571be"}[chunkId] + ".css";
};